/**
 * Дочірні типи модуля, з яких складається візуальна модель закону (прототип v4 lawViz): статті, впливи, колізії, пов'язані акти,
 * проблеми, які розв'язує закон, регульовані структури, зацікавлені сторони, правки, коментарі до тексту, версії й аналітичні записи
 * (правові проблеми, ризики, можливості, гіпотези, питання). Кожен посилається на законопроєкт полем-посиланням.
 */
export const LAW_TYPES: readonly string[] = [
  'ldart', 'ldimp', 'ldconf', 'ldlink', 'ldprob', 'ldorg', 'ldstake', 'ldedit', 'ldcom', 'ldver', 'lprob', 'lrisk', 'lopp', 'lhyp', 'lissue',
];
